import { Link } from "react-router-dom";
import { categories } from "@/mocks/siteData";

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">探索频道</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">六大内容板块，覆盖恋爱、婚姻、心理、综艺等热门领域</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/60 hover:border-accent-300/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-gradient-to-br ${cat.color} mb-3 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-background-50 text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{cat.count}个视频</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}